import { Typography } from '@mui/material'

export const Building = ({ value }) => {
  if (!value) return null
  return <Typography>{value}</Typography>
}
